import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateTournamentList = {
  tournamentList: { data: null, loading: false, error: null },
};

export const tournamentList = createAsyncThunk('user/tournamentList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/tournament/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerTournamentList = {
  [tournamentList.pending]: (state) => {
    state.tournamentList.loading = true;
  },
  [tournamentList.fulfilled]: (state, action) => {
    state.tournamentList.loading = false;
    state.tournamentList.data = action.payload;
    state.tournamentList.error = null;
  },
  [tournamentList.rejected]: (state, action) => {
    state.tournamentList.data = null;
    state.tournamentList.loading = false;
    state.tournamentList.error = action.payload;
  },
};
